import React, { useEffect, useState } from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Card } from 'reactstrap';
import { CardBody } from 'reactstrap';
import ApiService from '../../Services/ApiService';
import AlertService from '../../Services/alertService';
import { ERROR_KEY, MERCHANT_USER_TYPE_ID } from '../../Constants/MainKeys';
import { withRouter } from 'react-router-dom';

const StepLine = (props) => {

  // Statuses
  // 0 - error
  // 1 - pending
  // 2 - approved

  // Types
  // 0 "Account",
  // 1 "Company Information",
  // 2 "Business KYC",
  // 3 "Bank Account",
  // 4 "Significant Controllers",
  // 5 "API Key",

  const [data, setData] = useState([]);

  const { user } = useSelector((state) => state.Login);
  const { language } = useSelector(state => state.Languages);

  useEffect(() => {
    if (user && user.userTypeId === MERCHANT_USER_TYPE_ID) {
      checkMerchantAccount();
    }
  }, [user])

  const checkMerchantAccount = () => {
    ApiService.checkMerchantAccount().then(response => {
      if (response && response.data) {
        setData(response.data);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  const getItemIcon = (item) => {
    if (!item) { return false; }
    switch (item.type) {
      case 0:
        return <i className='item-icon bx bx-user'></i>
      case 1:
        return <i className='item-icon bx bx-buildings'></i>
      case 2:
        return <i className='item-icon bx bx-user-check'></i>
      case 3:
        return <i className='item-icon bx bxs-bank'></i>
      case 4:
        return <i className='item-icon bx bx-user-plus'></i>
      case 5:
        return <i className='item-icon bx bx-key'></i>
      default:
        break;
    }
  }

  // const getItemStatusIcon = (item) => {
  //   if (!item) { return false; }
  //   switch (item.status) {
  //     case 0:
  //       return <i className='item-status-icon bx bxs-x-circle'></i>
  //     case 1:
  //       return <i className='item-status-icon bx bxs-time-five'></i>
  //     case 2:
  //       return <i className='item-status-icon bx bxs-check-circle'></i>
  //     default:
  //       break;
  //   }
  // }

  const getItemName = (item) => {
    if (!item) { return false; }
    switch (item.type) {
      case 0:
        return <span>Account</span>
      case 1:
        return <span>Company Information</span>
      case 2:
        return <span>Business KYC</span>
      case 3:
        return <span>Bank Account</span>
      case 4:
        return <span>Significant Controllers</span>
      case 5:
        return <span>API Key</span>
      default:
        break;
    }
  }

  const drawStepLine = (item) => {
    if (!item) { return false; }
    return <div className={`step-line-item step-line-item-${item.status}`} onClick={() => redirectToCurrentPage(item)}>
      <div>
        {getItemIcon(item)}
      </div>
      {/* <div>
        {getItemStatusIcon(item)}
      </div> */}
      <div className='d-none d-md-block'>
        {getItemName(item)}
      </div>
    </div>
  }

  const redirectToCurrentPage = (item) => {
    if (!item) { return false; }
    switch (item.type) {
      case 0:
        return props.history.push(`/${language}/profile`)
      case 1:
        return props.history.push(`/${language}/merchant/company-information`)
      case 2:
        return props.history.push(`/${language}/merchant/business-details`)
      case 3:
        return props.history.push(`/${language}/bank-account`)
      case 4:
        return props.history.push(`/${language}/significant-controllers`)
      case 5:
        return props.history.push(`/${language}/api-keys`)
      default:
        break;
    }
  }

  if (!data.length) { return null }

  return (
    <>
      <Card>
        <CardBody>
          <div className='step-line'>
            <div className='d-flex gap-3 align-items-center'>
              <h5 className="m-0">KYC Status</h5>
            </div>

            <hr />
            <div className='d-flex justify-content-evenly'>
              {
                data.map((item, index) => {
                  if (item.type === 5 && user && !user.isActive) { return false; }
                  return <div key={index}>
                    <div>
                      {
                        item.messages && item.messages.length ?
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="bottom"
                            delay={{ show: 1, hide: 1 }}
                            overlay={<Tooltip id="button-tooltip">
                              {
                                item.messages && item.messages.length ?
                                  item.messages.map((message, messageIndex) => {
                                    return <p key={messageIndex} className='mb-1'>{message}</p>
                                  })
                                  : null
                              }
                            </Tooltip>}
                          >
                            {drawStepLine(item)}
                          </OverlayTrigger>
                          : drawStepLine(item)
                      }
                    </div>
                  </div>
                })
              }
            </div>
          </div>
        </CardBody>
        <div className='step-line p-3' style={{ backgroundColor: "#ffffe0" }}>
          <div className='d-flex flex-wrap mt-1'>
            <small className='d-block me-3'>Legend</small>
            <div className='d-flex align-items-center me-4'><span className='step-dot step-dot-0' /><small>New (not started yet)</small></div>
            <div className='d-flex align-items-center me-4'><span className='step-dot step-dot-1' /><small>Pending (waiting for admin approval)</small></div>
            <div className='d-flex align-items-center me-4'><span className='step-dot step-dot-2' /><small>Completed (successfully confirmed)</small></div>
          </div>
        </div>
      </Card>

    </>
  )
}

export default withRouter(StepLine)